module.exports = __webpack_public_path__ + "img/holdings--icon.a245dfca.svg";